<template>
  <c-link
    v-bind="$attrs"
    :external="external"
    :target="target"
    :to="to"
    @click="$emit('click')"
    @mouseenter.native="$emit('mouseenter', $event)"
    @mouseleave.native="$emit('mouseleave', $event)"
  >
    <slot />
  </c-link>
</template>

<script>
import CLink from '@convenia/components/CLink'

export default {
  name: 'SidebarLink',

  components: {
    CLink
  },

  props: {
    external: Boolean,

    target: {
      type: String,
      default: '_self'
    },

    to: {
      type: [ String, Object ],
      default: ''
    }
  }
}
</script>
